import React from 'react';
import Carousel from './Carousel';
import Inicio from './Inicio';

const Home = () => {
  return (
    <div>
      <Carousel />
      <Inicio />
    </div>
  );
};

export default Home;